import { Button } from "@/components/ui/button";

interface ModeSelectorProps {
  currentMode: "chat" | "debate" | "autonomous";
  onModeChange: (mode: "chat" | "debate" | "autonomous") => void;
}

export const ModeSelector = ({ currentMode, onModeChange }: ModeSelectorProps) => {
  const modes = [
    { id: "chat", label: "Chat" },
    { id: "debate", label: "Debate" },
    { id: "autonomous", label: "Autonomous" },
  ] as const;

  return (
    <div className="px-6 py-4 border-t border-border">
      <div className="flex gap-2">
        {modes.map((mode) => (
          <Button
            key={mode.id}
            variant={currentMode === mode.id ? "default" : "ghost"}
            onClick={() => onModeChange(mode.id)}
            className={`
              px-6 py-2 rounded-full text-sm
              ${currentMode === mode.id 
                ? "bg-primary text-primary-foreground" 
                : "text-muted-foreground hover:text-foreground hover:bg-accent"
              }
            `}
          >
            {mode.label}
          </Button>
        ))}
      </div>
    </div>
  );
};